import React, { Component } from 'react';

import './index.css'
import request from '../client/client';

class FormCategory extends Component {

  state = {
    description: ""
  }
  handleChange = (e) => {
    this.setState({
      description: e.target.value
    })
    this.props.onChange(e.target.value);
  }

  render() {
    return (
      <div className="text-center">
        <form className="pt-0">
          <input
            className="form-item"
            placeholder="Nome da categoria"
            name="description"
            type="text"
            onChange={this.handleChange.bind()}

          />
          
        </form>
      </div>
    )
  }
}

export default FormCategory;



// WEBPACK FOOTER //
// ./src/components/form-category/index.js